import { Component, Inject, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { MenuIdService } from './service/menu-id.service';
import { RestService } from './service/rest.service';
import { DOCUMENT } from '@angular/common';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from './service/loader.service';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './service/common.service';
import { AuthInterceptor } from './core/auth-interceptor';
import { TokenStorage } from './core/token-storage';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  defaultLanguage: string = 'en'; // Default language variable
  timeInterval: any;
  isLogin: boolean = true;
  receivedData: any;
  isModules = false;
  screenConfigId: any;
  url: any;
  orgAppScreens: any;
  showHelpIcon: boolean = false;
  orgHelpScreenData: string = '';
  title!: '';
  private breadcrumbHistory: any[] = [];
  lastBreadcrumbIndex: number | null = null;
  isScrnConfig = false;
  menuID: number;
  img!: string;
  redirect_url: any;
  orgAppId: any;
  domains: any;
  domainId:any;
  constructor(
    private titleService: Title,
    public Translate: TranslateService,
    public MenuIdService: MenuIdService,
    private restService: RestService,
    private router: Router,
    private cookieService: CookieService,
    private loader: LoaderService,
    private route: ActivatedRoute,
    public http: HttpClient,
    private commonService: CommonService,
    private token: TokenStorage 
  ) {
    this.route.queryParams.subscribe(params => {
      this.url = params['redirect_url'];
    });
    const params = this.getParamsFromCurrentUrl();
    this.redirect_url = this.cookieService.get('redirect_url');
    this.setLanguage(this.defaultLanguage); // Set the default language
    this.loadAdditionalTranslations(this.defaultLanguage);
    // Add this line to set up the popstate event handler (e.g., in your component's constructor)
    window.addEventListener('popstate', () => this.handlePopState());
    this.dynamicUIOnChange();

  }

  loadDomains() {
    this.http.get<any[]>('assets/jsons/domain.json').subscribe(data => {
      this.domains = data;
      this.matchDomain();
    });
  }

  matchDomain() {
    const redirectUrl = this.cookieService.get('redirect_url');
    if (!redirectUrl) {
      console.log('No redirect URL found.');
      return;
    }

    // Create an array of domain names from this.domains
    const domainNames = this.domains.map(domain => domain.domain);

    // Check if any of the domainNames is included in the redirectUrl
    const matchedDomain = this.domains.find(domain => redirectUrl.includes(domain.domain));

    if (matchedDomain) {
      this.orgAppId = matchedDomain.orgAppId; // Safely get orgAppId
      const domain = '.insure.digital'; // Set for root domain
      const domain1 = '.swiftant.com'; // Set for root domain

      // Set the redirect_url cookie regardless of orgAppId presence
      this.cookieService.set('redirect_url', redirectUrl, null, '/', 'localhost', false, 'Strict');
      this.cookieService.set('redirect_url', redirectUrl, null, '/', domain, false, 'Strict');
      this.cookieService.set('redirect_url', redirectUrl, null, '/', domain1, false, 'Strict');

      if (this.orgAppId) {
        // Set the orgAppId cookie only if orgAppId is present
        this.cookieService.set('orgAppId', this.orgAppId, null, '/', 'localhost', false, 'Strict');
        this.cookieService.set('orgAppId', this.orgAppId, null, '/', domain, false, 'Strict');
        this.cookieService.set('orgAppId', this.orgAppId, null, '/', domain1, false, 'Strict');
        console.log('Matched orgAppId:', this.orgAppId);
      }
    } else {
      console.log('No matching domain found.');
    }
  }



  dynamicUIOnChange() {
    const currentUrl = this.redirect_url;
    switch (true) {
      case currentUrl.includes('uat-core-primez.insure.digital.com'):
      case currentUrl.includes('uat-core'):
        //case currentUrl.includes('.insure.digital'):
        this.MenuIdService.getImagePath(6130, 'uat-core-primez.insure.digital.com');
        this.MenuIdService.getWelcomMsg('uat-core-primez.insure.digital.com')
        this.MenuIdService.getFooterContent('uat-core-primez.insure.digital.com');
        this.MenuIdService.getUserActivateContent('uat-core-primez.insure.digital.com');
        this.menuID = 6130;
        document.body.classList.add('afrisure');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/afrisurefaviconlogo.png');
        break;
      case currentUrl.includes('malawi.com'):
      case currentUrl.includes('malawi'):
        this.MenuIdService.getImagePath(6050, 'malawi.com'); // malawi
        this.MenuIdService.getFooterContent('malawi.com');
        this.MenuIdService.getUserActivateContent('malawi.com');
        this.menuID = 6050;
        document.body.classList.add('malawi');
        this.changeBrowserTitle('DMVIC-IAM-MOTOR');
        this.changeFavicon('assets/images/faviconLogo/IAM2_favicon.png');
        break;
      case currentUrl.includes('csr.swiftant.com'):
        this.MenuIdService.getImagePath(6140, 'csr.swiftant.com');
        this.MenuIdService.getFooterContent('csr.swiftant.com');
        this.MenuIdService.getWelcomMsg('csr.swiftant.com')
        this.MenuIdService.getUserActivateContent('csr.swiftant.com');
        this.menuID = 6140;
        document.body.classList.add('csr');
        this.changeBrowserTitle('CSR CAMS');
        this.changeFavicon('assets/images/csr-logo.png');
        break;
      case currentUrl.includes('swiftb2b.insure.digital'):
        this.MenuIdService.getImagePath(6150, 'swiftb2b.insure.digital');
        this.MenuIdService.getFooterContent('swiftb2b.insure.digital');
        this.MenuIdService.getWelcomMsg('swiftb2b.insure.digital');
        this.MenuIdService.getUserActivateContent('swiftb2b.insure.digital');
        this.menuID = 6150;
        document.body.classList.add('swiftb2b');
        this.changeBrowserTitle('SwiftB2B');
        this.changeFavicon('assets/images/swiftb2b-fav-icon.svg');
        break;
      case currentUrl.includes('kenindia-travel.insure'):
        this.MenuIdService.getImagePath(6120, 'kenindia-travel.insure.digital');
        this.MenuIdService.getFooterContent('kenindia-travel.insure.digital');
        this.MenuIdService.getWelcomMsg('kenindia-travel.insure.digital');
        this.MenuIdService.getUserActivateContent('kenindia-travel.insure.digital');
        this.menuID = 6120;
        document.body.classList.add('kenindia');
        this.changeBrowserTitle('Kenindia');
        this.changeFavicon('assets/images/x-icon.jpg');
        break;
      case currentUrl.includes('localhost'):
        this.MenuIdService.getImagePath(6130, 'localhost');
        this.MenuIdService.getFooterContent('localhost');
        this.MenuIdService.getWelcomMsg('localhost');
        this.MenuIdService.getUserActivateContent('localhost');
        this.menuID = 6130;
        document.body.classList.add('afrisure');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/afrisurefaviconlogo.png');
        break;
      case currentUrl.includes('uaedemo-primez.insure.digital'):
        this.MenuIdService.getImagePath(6130, 'uaedemo-primez.insure.digital');
        this.menuID = 6130;
        document.body.classList.add('primeZ');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
        this.MenuIdService.getFooterContent('uaedemo-primez.insure.digital');
        // this.menuID = 6050;
        // document.body.classList.add('malawi');
        // this.changeBrowserTitle('DMVIC-IAM-MOTOR');
        // this.changeFavicon('assets/images/faviconLogo/IAM2_favicon.png');
        break;
      case currentUrl.includes('sudlife-primez.insure.digital'):
        this.MenuIdService.getImagePath(6130, 'sudlife-primez.insure.digital');
        this.menuID = 6130;
        document.body.classList.add('primeZ');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
        this.MenuIdService.getFooterContent('sudlife-primez.insure.digital');
        break;
      case currentUrl.includes('cholams-primez.insure.digital'):
        this.MenuIdService.getImagePath(6130, 'cholams-primez.insure.digital');
        this.menuID = 6130;
        document.body.classList.add('primeZ');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
        this.MenuIdService.getFooterContent('cholams-primez.insure.digital');
        break;
      case currentUrl.includes('zuno-primez.insure.digital'):
        this.MenuIdService.getImagePath(6130, 'zuno-primez.insure.digital');
        this.menuID = 6130;
        document.body.classList.add('primeZ');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/faviconLogo/afrisurefaviconlogo.png');
        this.MenuIdService.getFooterContent('zuno-primez.insure.digital');
        break;
      case currentUrl.includes('starhealth-primez.insure.digital'):
        this.MenuIdService.getImagePath(6130, 'starhealth-primez.insure.digital');
        this.menuID = 6130;
        document.body.classList.add('primeZ');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/afrisurefaviconlogo.png');
        this.MenuIdService.getFooterContent('starhealth-primez.insure.digital');
        break;
      case currentUrl.includes('qa-pc-primez.insure.digital'):
        this.MenuIdService.getImagePath(6170, 'qa-pc-primez.insure.digital');
        this.menuID = 6170;
        document.body.classList.add('afrisure');
        this.changeBrowserTitle('Afrisure');
        this.changeFavicon('assets/images/afrisurefaviconlogo.png');
        this.MenuIdService.getFooterContent('qa-pc-primez.insure.digital');
        break;
      case currentUrl.includes('nyala'):
        this.MenuIdService.getImagePath(6130, 'nyala-primez.insure.digital');
        this.menuID = 6130;
        document.body.classList.add('afrisure');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/afrisurefaviconlogo.png');
        this.MenuIdService.getFooterContent('nyala-primez.insure.digital');
        break;
      case currentUrl.includes('swa-afrisure.insure.digital'):
        this.MenuIdService.getImagePath(6130, 'uat-core-primez.insure.digital.com');
        this.menuID = 6130;
        document.body.classList.add('afrisure');
        this.changeBrowserTitle('Core-Insurance');
        this.changeFavicon('assets/images/afrisurefaviconlogo.png');
        this.MenuIdService.getFooterContent('uat-core-primez.insure.digital.com');
        break;
        case currentUrl.includes('common'):
          this.MenuIdService.getImagePath(6130, 'uat-core-primez.insure.digital.com');
          this.menuID = 6130;
          document.body.classList.add('afrisure');
          this.changeBrowserTitle('Core-Insurance');
          this.changeFavicon('assets/images/afrisurefaviconlogo.png');
          this.MenuIdService.getFooterContent('uat-core-primez.insure.digital.com');
          break;
          case currentUrl.includes(''):
            this.MenuIdService.getImagePath(6130, 'uat-core-primez.insure.digital.com');
            this.menuID = 6130;
            document.body.classList.add('afrisure');
            this.changeBrowserTitle('Core-Insurance');
            this.changeFavicon('assets/images/afrisurefaviconlogo.png');
            this.MenuIdService.getFooterContent('uat-core-primez.insure.digital.com');
            break;
    }

  }

  ngOnInit(): void {

    if(this.token.getToken()){
     this.generateAccessCode()
    }
    this.timeInterval = setInterval(() => {
      if (sessionStorage.getItem('breadCrumbs')) {
        this.receivedData = sessionStorage.getItem('breadCrumbs');
      }
      this.isScrnConfig =
        window.location.pathname.includes('screen-configurer') ||
          window.location.pathname.includes('screen-stepper-config')
          ? true
          : false;
      this.isModules =
        window.location.pathname.includes('forms') ||
          window.location.pathname.includes('product-config') ||
          window.location.pathname.includes('auth') ||
          window.location.pathname.includes('home') ||
          window.location.pathname.includes('error') ||
          window.location.pathname.includes('create-module-config') ||
          window.location.pathname.includes('screen-config') ||
          window.location.pathname.includes('widgets') ||
          window.location.pathname.includes('help-document') ||
          window.location.pathname.includes('org-structure') ||
          window.location.pathname.includes('/view/policy_underwriting/')
          ? true
          : false;
      this.isLogin = window.location.pathname.includes('login') ? true : false;
    }, 500 * 1);
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        // The URL has changed
        window.scroll(0, 0);
        // You can perform actions or call functions here
        this.url = event.url;
        const urlSegments = event.url.split('/');
        const idPattern =
          /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
        const screenConfigId = urlSegments.find((segment) =>
          idPattern.test(segment)
        );

        if (screenConfigId) {
          let url_parts = this.url?.split('/');
          this.screenConfigId = url_parts[url_parts.length - 1];
          // if (!this.isModules && !this.shouldHideBreadCrumbs() && !window.location.pathname.includes('forms'))
          //   this.fetchHelpScreen();
        }
      }
    });
  }
  getParamsFromCurrentUrl(): { redirect_url: string; } | null {
    try {
      // Get the current URL from the window object
      const url = window.location.href;
      // Parse the URL
      const urlObj = new URL(url);
      // Get the search parameters from the URL
      const params = new URLSearchParams(urlObj.search);
      // Get the redirect_url and orgAppId parameters
      const redirect_url = params.get('redirect_url');
      // Check if both parameters are present
      if (redirect_url) {
        // Decode the redirect_url and return both parameters
        return { redirect_url: decodeURIComponent(redirect_url) };
      }
      return null;
    } catch (error) {
      console.error('Invalid URL', error);
      return null;
    }
  }

  handlePopState() {
    // Get the index of the last breadcrumb in the history
    // this.breadcrumbHistory = JSON.parse(
    //   sessionStorage.getItem('BCArray') || ''
    // );
    // const lastBreadcrumbIndex = this.breadcrumbHistory.findIndex((bc: any) =>
    //   window.location.pathname.includes(bc.url)
    // );
    // this.receivedData =
    //   this.breadcrumbHistory[lastBreadcrumbIndex]?.breadCrumb || '';
    // sessionStorage.setItem('breadCrumbs', this.receivedData);
  }

  handleDataFromMenu(data: any) {
    this.receivedData = data;
  }

  loadAdditionalTranslations(language: string) {
    this.restService
      .getData<any>('assets/apitest.json', true)
      .subscribe((data) => {
        this.Translate.setTranslation(language, {
          ...this.Translate.translations[language],
          ...data,
        });

        this.setLanguage(this.defaultLanguage);
      });
  }

  setLanguage(language: string) {
    this.Translate.setDefaultLang(language); // Set default language
    this.Translate.use(language); // Use the specified language
  }

  openHelpDocument() {
    const windowFeatures = 'height=600,width=1100,scrollbars=yes,resizable=yes';

    window.open(
      `/create/help-document-new/${this.screenConfigId}`,
      '_blank',
      windowFeatures
    );
  }

  shouldHideBreadCrumbs(): boolean {
    return (
      this.router.url.includes('help-document-new') ||
      this.router.url.includes('view/my-profile') ||
      this.router.url.includes('view/view-profile') ||
      this.router.url.includes('view/routing-module') ||
      this.router.url.includes('auth/login'))

  }
  shoulHideMenu() {
    return (
      this.router.url.includes('help-document-new') ||
      this.router.url.includes('auth/forgot_password') ||
      this.router.url.includes('error/error-status')
    );
  }

  fetchHelpScreen() {
    this.showHelpIcon = false;
    let params = {
      screenConfigID: this.screenConfigId,
      versionID: '1',
    };
    this.restService
      .postData(
        params,
        'api/digital/core/ScreenConfiguration/FetchOrgAppHelpScreen'
      )
      .subscribe({
        next: (data) => {
          if (data.rcode === 200) {
            this.orgHelpScreenData = data.rObj.screenHelp;
            //console.log(this.orgHelpScreenData)
            if (this.orgHelpScreenData) {
              this.showHelpIcon = true;
            }
          }
        },
      });
  }

  changeBrowserTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }
  changeFavicon(newFaviconPath: string) {
    const favicon = document.getElementById(
      'dynamic-favicon'
    ) as HTMLLinkElement;
    if (favicon) {
      favicon.href = newFaviconPath;
    }
  }
  // getImagePath(): string {
  //   return this.img
  // }

  // getMenuID() {
  //   return this.menuID
  // }
  back() {
    history.back()
  }
  generateAccessCode(){
  let reqId = localStorage.getItem('reqID')
    this.loader.show();
    let param = {
      "orgAppAuthRequestID": reqId
    }
    this.restService.postUATData(param, 'api/digital/core/Account/GetAccessCode').subscribe(
      (data) => {
        if (data.rcode == 200) {
          this.loader.hide();
          let redirect_url = data.rObj.redirectURL
            if(redirect_url){
              window.location.href = redirect_url
               
            }
        }
        else {
          this.commonService.handleRcodeError(data)
        }
      },
      (error) => {
        this.commonService.handleStatusError(error);
      }
    );
    
}
}
